const schema = [
  {
    key: 'tradingProgressStatusCd',
    label: 'Trading Flow Status',
    dataType: 'TradingStatusIcon',
    sortTarget: 'TRADING_PROGRESS_STATUS_CD',
    sortable: true,
    width: 60,
    align: 'center',
    resizable: true,
    column: 'default',
  },
  {
    key: 'tradingManageName',
    label: 'Flow Name',
    dataType: 'String',
    sortTarget: 'TRADING_MANAGE_NAME',
    sortable: true,
    width: 320,
    resizable: true,
    column: 'default',
  },
  {
    key: 'exInvoiceNo',
    label: 'Ex Custom Invoice No',
    dataType: 'String',
    sortTarget: 'EX_INVOICE_NO',
    sortable: true,
    width: 320,
    resizable: true,
    column: 'default',
  },
  {
    key: 'commercialInvoiceNo',
    label: 'Commercial Invoice No',
    dataType: 'String',
    sortTarget: 'COMMERCIAL_INVOICE_NO',
    sortable: true,
    width: 320,
    resizable: true,
    column: 'default',
  },
  {
    key: 'imInvoiceNo',
    label: 'Im Custom Invoice No',
    dataType: 'String',
    sortTarget: 'IM_INVOICE_NO',
    sortable: true,
    width: 320,
    resizable: true,
    column: 'default',
  },
  {
    key: 'poNo',
    label: 'P/O No',
    dataType: 'String',
    sortTarget: 'PO_NO',
    sortable: true,
    width: 100,
    resizable: true,
    column: 'default'
  },
  {
    key: 'contractNo',
    label: 'Contract No',
    dataType: 'String',
    sortTarget: 'CONTRACT_NO',
    sortable: true,
    width: 100,
    resizable: true,
    column: 'default',
  },
  {
    key: 'contractDate',
    label: 'Contract Date',
    dataType: 'Date',
    sortTarget: 'CONTRACT_DATE',
    sortable: true,
    width: 100,
    resizable: true,
    column: 'default',
  },
  {
    key: 'tradeTypeCdDisplay',
    label: 'Trading Type',
    dataType: 'TradeTypeCdDisplay',
    sortTarget: 'TRADE_TYPE_CD',
    sortable: false,
    width: 80,
    resizable: true,
    column: 'default',
  },
  {
    key: 'sellerName',
    label: 'Seller',
    dataType: 'String',
    sortTarget: 'SELLER_NAME',
    sortable: true,
    width: 320,
    resizable: true,
    column: 'default',
  },
  {
    key: 'buyerName',
    label: 'Buyer',
    dataType: 'String',
    sortTarget: 'BUYER_NAME',
    sortable: true,
    width: 320,
    resizable: true,
    column: 'default',
  },
  {
    key: 'contractGroupOfGoods',
    label: 'Main Goods',
    dataType: 'String',
    sortTarget: 'CONTRACT_GROUP_OF_GOODS',
    sortable: true,
    width: 102,
    resizable: true,
    column: 'default',
  },
  {
    key: 'contractTotalQuantity',
    label: 'Total Quantity',
    dataType: 'Quantity',
    target: 'contractQuantityUnit',
    sortTarget: 'CONTRACT_TOTAL_QUANTITY',
    sortable: true,
    width: 100,
    align: 'right',
    resizable: true,
    column: 'default',
  },
  {
    key: 'contractTotalAmount',
    label: 'Total Amount',
    dataType: 'Currency',
    target: 'contractCurrencyId',
    sortTarget: 'CONTRACT_TOTAL_AMOUNT',
    sortable: true,
    width: 100,
    align: 'right',
    resizable: true,
    column: 'default',
  },
  {
    key: 'deliveryTermsCd',
    label: 'Delivery Terms',
    dataType: 'DeliveryTermsCd',
    sortTarget: 'DELIVERY_TERMS_CD',
    sortable: true,
    width: 100,
    resizable: true,
    column: 'default',
  },
  {
    key: 'paymentTermsCd',
    label: 'Payment Terms',
    dataType: 'PaymentTermsCd',
    sortTarget: 'PAYMENT_TERMS_CD',
    sortable: true,
    width: 100,
    resizable: true,
    column: 'default',
  },
  {
    key: 'nameOfVessel',
    label: 'Vessel Name',
    dataType: 'String',
    sortTarget: 'NAME_OF_VESSEL',
    sortable: true,
    width: 200,
    resizable: true,
    column: 'default',
  },
  {
    key: 'blNo',
    label: 'B/L No',
    dataType: 'String',
    sortTarget: 'BL_NO',
    sortable: true,
    width: 100,
    resizable: true,
    column: 'default',
  },
  {
    key: 'vesselBookingNo',
    label: 'Booking No',
    dataType: 'String',
    sortTarget: 'VESSEL_BOOKING_NO',
    sortable: true,
    width: 120,
    resizable: true,
    column: 'default',
  },
  {
    key: 'numberOfContainers',
    label: 'No of Containers',
    dataType: 'String',
    sortTarget: 'NUMBER_OF_CONTAINERS',
    sortable: true,
    width: 110,
    resizable: true,
    column: 'default',
  },
  {
    key: 'blDate',
    label: 'ETD/BL Date',
    dataType: 'Date',
    sortTarget: 'BL_DATE',
    sortable: true,
    width: 120,
    resizable: true,
    column: 'default',
  },
  {
    key: 'loadingPortCurrentEtd',
    label: 'Current ETD',
    dataType: 'String',
    sortTarget: 'LOADING_PORT_CURRENT_ETD',
    sortable: true,
    width: 100,
    resizable: true,
    column: 'default'
  },
  {
    key: 'loadingPortAtd',
    label: 'ATD',
    dataType: 'String',
    sortTarget: 'LOADING_PORT_ATD',
    sortable: true,
    width: 100,
    resizable: true,
    column: 'default'
  },
  {
    key: 'eta',
    label: 'ETA',
    dataType: 'Date',
    sortTarget: 'ETA',
    sortable: true,
    width: 100,
    resizable: true,
    column: 'default',
  },
  {
    key: 'dischargingCurrentEta',
    label: 'Discharging Current ETA',
    dataType: 'Date',
    sortTarget: 'DISCHARGING_CURRENT_ETA',
    sortable: true,
    width: 100,
    resizable: true,
    column: 'default',
  },
  {
    key: 'dischargingAta',
    label: 'ATA',
    dataType: 'String',
    sortTarget: 'DISCHARGING_ATA',
    sortable: true,
    width: 100,
    resizable: true,
    column: 'default'
  },
  {
    key: 'portOfLoadingName',
    label: 'Port of Loading',
    dataType: 'String',
    sortTarget: 'PORT_OF_LOADING_NAME',
    sortable: true,
    width: 200,
    resizable: true,
    column: 'default',
  },
  {
    key: 'portOfDischargingName',
    label: 'Port of Discharging',
    dataType: 'String',
    sortTarget: 'PORT_OF_DISCHARGING_NAME',
    sortable: true,
    width: 200,
    resizable: true,
    column: 'default',
  },
  {
    key: 'exRequestDeclarationDate',
    label: 'Ex Request Declaration Date',
    dataType: 'Date',
    sortTarget: 'EX_REQUEST_DECLARATION_DATE',
    sortable: true,
    width: 150,
    resizable: true,
    column: 'default',
  },
  {
    key: 'vanningDate',
    label: 'Vanning Date',
    dataType: 'Date',
    sortTarget: 'VANNING_DATE',
    sortable: true,
    width: 120,
    resizable: true,
    column: 'default',
  },
  {
    key: 'vanningPlace',
    label: 'Place of Vanning',
    dataType: 'String',
    sortTarget: 'VANNING_PLACE',
    sortable: true,
    width: 200,
    resizable: true,
    column: 'default',
  },
  {
    key: 'cyCutDate',
    label: 'CY CUT',
    dataType: 'Date',
    sortTarget: 'CY_CUT_DATE',
    sortable: true,
    width: 100,
    resizable: true,
    column: 'default',
  },
  {
    key: 'imRequestDeclarationDate',
    label: 'Im Request Declaration Date',
    dataType: 'Date',
    sortTarget: 'IM_REQUEST_DECLARATION_DATE',
    sortable: true,
    width: 150,
    resizable: true,
    column: 'default',
  },
  {
    key: 'scheduledDeliveryDate',
    label: 'Scheduled Delivery Date',
    dataType: 'Date',
    sortTarget: 'SCHEDULED_DELIVERY_DATE',
    sortable: true,
    width: 100,
    resizable: true,
    column: 'default'
  },
  {
    key: 'deliveryDate',
    label: 'Delivery Date',
    dataType: 'Date',
    sortTarget: 'DELIVERY_DATE',
    sortable: true,
    width: 100,
    resizable: true,
    column: 'default',
  },
  {
    key: 'scheduledDevanningDate',
    label: 'Scheduled Devanning Date',
    dataType: 'Date',
    sortTarget: 'SCHEDULED_DEVANNING_DATE',
    sortable: true,
    width: 120,
    resizable: true,
    column: 'default'
  },
  {
    key: 'freeTime',
    label: 'Free Time',
    dataType: 'Date',
    sortTarget: 'FREE_TIME',
    sortable: true,
    width: 110,
    resizable: true,
    column: 'default',
  },
  {
    key: 'devanningPlace',
    label: 'Place of Devanning',
    dataType: 'String',
    sortTarget: 'DEVANNING_PLACE',
    sortable: true,
    width: 200,
    resizable: true,
    column: 'default',
  },
  {
    key: 'warehouse',
    label: 'Warehouse',
    dataType: 'String',
    sortTarget: 'WAREHOUSE',
    sortable: true,
    width: 200,
    resizable: true,
    column: 'default',
  },
  {
    key: 'modeOfTransportation',
    label: 'Transportation',
    dataType: 'Transportation',
    sortTarget: 'MODE_OF_TRANSPORTATION',
    sortable: false,
    width: 100,
    resizable: true,
    column: 'default'
  },
  {
    key: 'typeOfServiceFrom',
    label: 'Type Of Service From',
    dataType: 'TypeOfServiceFclLcl',
    sortTarget: 'TYPE_OF_SERVICE_FROM',
    sortable: false,
    width: 100,
    resizable: true,
    column: 'default'
  },
  {
    key: 'hazardousFlag',
    label: 'Hazardous',
    dataType: 'hazardous',
    sortTarget: 'HAZARDOUS_FLAG',
    sortable: false,
    width: 100,
    resizable: true,
    column: 'default'
  },

  {
    key: 'flowReference',
    label: 'Flow Reference',
    dataType: 'String',
    sortTarget: 'FLOW_REFERENCE',
    sortable: true,
    width: 200,
    resizable: true,
    column: 'default'
  },
  {
    key: 'flowUserName',
    label: 'Flow PIC',
    dataType: 'String',
    sortTarget: 'FLOW_USER_NAME',
    sortable: true,
    width: 200,
    resizable: true,
    column: 'default'
  },
  {
    key: 'forcedClose',
    label: 'Hidden Flow',
    dataType: 'ForcedClose',
    sortTarget: 'FORCED_CLOSE',
    sortable: true,
    width: 100,
    resizable: true,
    column: 'default'
  },

  {
    key: 'owner',
    label: 'Owner',
    dataType: 'Customer',
    sortTarget: 'OWNER_COMPANY_SHORT_NAME',
    sortable: true,
    width: 120,
    resizable: true,
    column: 'default',
  },
  {
    key: 'tradingFlowId',
    label: 'Trading/Flow ID',
    dataType: 'TradingFlowId',
    sortTarget: 'TRADING_ID',
    sortable: true,
    width: 184,
    resizable: true,
    column: 'default',
  },
  {
    key: 'tradingChannelInfo.tradingChannelNo',
    label: 'TC No',
    dataType: 'String',
    sortTarget: 'TRADING_CHANNEL_NO',
    sortable: true,
    width: 150,
    resizable: true,
    column: 'default',
  },
  {
    key: 'flowCreateDate',
    label: 'Create Datetime',
    dataType: 'DateTime',
    sortTarget: 'FLOW_CREATE_DATE',
    sortable: true,
    width: 160,
    resizable: true,
    column: 'default',
  },
  {
    key: 'flowUpdateDate',
    label: 'Update Datetime',
    dataType: 'DateTime',
    sortTarget: 'FLOW_UPDATE_DATE',
    sortable: true,
    width: 140,
    resizable: true,
    column: 'default',
  },
  {
    key: 'tradingName',
    label: 'Trading Name',
    dataType: 'String',
    sortTarget: 'TRADING_NAME',
    sortable: true,
    width: 320,
    resizable: true,
    column: 'default',
  },
  // {
  //   key: 'entityStatus',
  //   label: 'Process Status',
  //   dataType: 'EntityList',
  //   sortable: false,
  //   resizable: true,
  //   column: 'default',
  // },
];

export const tradingFlowListTableSchema = schema.map( item => ({
  ...item,
  prop: item.key,
}))
